import loadable from '@loadable/component';

export const LazyBrandsList = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/brandslist" */
      '.'
    ),
);
